import { render } from "./Ledger_Balances.vue?vue&type=template&id=9749d912"
import script from "./Ledger_Balances.vue?vue&type=script&lang=js"
export * from "./Ledger_Balances.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__